import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from 'src/app/shared/services/request/request.service';

export interface ListarTarefasEmpresaPayload {
  targetCompanyID: number;
  responsibleID: number;
  actionID: number;
  moduleID: number;
  dateBegin: string | null;
  dateEnd: string | null;
  situation: string;
  name: string | null;
  pagination: {
    page: number;
    pageSize: number;
    shortcuts: number;
  };
}

export interface EditarTarefaEmpresaPayload {
  taskID: number;
  responsibleID: number;
  actionID: number;
  followUp: string;
  description: string;
}

export interface CriarTarefaEmpresaPayload {
  targetCompanyID: number;
  contactIds: number[];
  responsibleID: number;
  actionID: number;
  followUp: string;
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class TarefasEmpresaService {
  constructor(private readonly _requestService: RequestService) {}

  listarTarefas(body: ListarTarefasEmpresaPayload): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/CompanyTask/ListCompanyTasks',
      'POST',
      true,
      body,
    );
  }

  listarAcoes(): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/CompanyTask/ListTaskActions',
      'GET',
      true,
      null,
    );
  }


  criarTarefa(body: CriarTarefaEmpresaPayload): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/CompanyTask/CreateCompanyTask',
      'POST',
      true,
      body,
    );
  }

  editarTarefa(body: EditarTarefaEmpresaPayload): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/CompanyTask/EditCompanyTask',
      'PUT',
      true,
      body,
    );
  }

  alterarStatus(taskId: number, status: number): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/CompanyTask/${taskId}/set-status/${status}`,
      'POST',
      true,
      null,
    );
  }

  excluirTarefa(taskId: number): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/CompanyTask/${taskId}/DeleteCompanyTask`,
      'DELETE',
      true,
      null,
    );
  }

  listTaskCompanies(): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/CompanyTask/ListTaskCompanies',
      'GET',
      true,
      null,
    );
  }
}
